import axios from 'axios'

export type TelematicsType = 'PRE_BIND' | 'POST_BIND'

export function exchangeTerminalToken(
  publicToken: string,
  type: TelematicsType = 'PRE_BIND',
  userId?: string
) {
  return axios.post(
    '/api/v1/insure/terminal/exchange-token/',
    { public_token: publicToken, type },
    userId ? { params: { user_id: userId } } : undefined
  )
}
